import Http from "../../common/request";

export const sendEmailVerificationCode = (email: string) => {
    return Http.post('/user/api/login/mail/sendMailCode', { email })
}

export const loginByEmail = (email: string, code: string) => {
    return Http.post('/user/api/login/mail/mailLogin', { email, code })
}

export const loginByThird = (accessToken: string, openType: number) => {
    return Http.post('/user/api/login/base/thirdLogin', { accessToken, openType })
}